import { gramsToKgs } from "@./cat-calculations";
import { useTranslations } from "next-intl";

export const useCatWeight = (grams: number | null) => {
  const tVocabulary = useTranslations("Shared.Vocabulary");

  if (!grams) {
    return tVocabulary("unknown");
  }

  return `${gramsToKgs(grams)}kg`;
};
